import { actionGenerator, IReduxAction } from '../utils/actions';

export const RESET_STATE = 'RESET_STATE';

export type TResetStateAction = IReduxAction<typeof RESET_STATE>;

export const resetState = actionGenerator<typeof RESET_STATE>(RESET_STATE);
